export default __webpack_public_path__ + "static/media/typescript.31f8fee8.svg";